export default __webpack_public_path__ + "maps-examples-runtime-animate-line-thumbnail-960-63d8f0045c47866abacc070436bf5446.webp";